export const PORTABLE_RESTROOM_TRAILER = 'Portable Restroom Trailer';
